// Components
import { Grid } from '@mui/material';
import InputColor from 'react-input-color';

// Custom components
import { AntSwitch, AntSwitchControlLabel, CustomButtonV2, CustomFormLabel, CustomTextField, ModalFooter, ModalHeader, ModalSubHeader } from '../../../../pages/styles';

// Styles
import {
    Container,
    Body,
    ContainerInfo,
    SectionRight,
    ContainerInputColor,
	CustomDivider,
} from './styles'

// Utils
import { useTranslation } from 'react-i18next'
import { getIcon } from '../../../../utils/iconConfig';
import Router from '../../../../router';
import { SelectInput } from '../../../SelectInput';
import { SaveOutlined } from '@mui/icons-material';

export const StandardWorkflowFormCard = ({
    title,
    form,
    errors,
    roles,
    executeOptions,
    isAssignRole,
    handleClose,
    handleSave,
    handleChange,
    isStandardFlow
}) => {
    const { t } = useTranslation();

    return (
        <Container>
            {!isAssignRole &&
				<>
					<ModalHeader>{title}</ModalHeader>
					<ModalSubHeader/>
				</>
			}
            <Body isStandardFlow={isStandardFlow}>
                <ContainerInfo disabled={isAssignRole ? 'true' : 'false'}>
                    <Grid container spacing={2}>
						<Grid item xs={12} sm={6} lg={isStandardFlow ? 6 : 3}>
							<CustomTextField
								placeholder={t('standardStatus.table.title')}
								label={t('standardStatus.table.title')}
								value={form.title}
								onChange={e => handleChange(e, 'title')}
								sx={{ width: '100%' }}
								error={!(!errors?.title?.error)}
								helperText={errors?.title?.error}
								disabled={isAssignRole}
							/>
						</Grid>

						<Grid item xs={12} sm={6} lg={isStandardFlow ? 6 : 3}>
							<CustomTextField
								placeholder={t('standardStatus.table.description')}
								label={t('standardStatus.table.description')}
								value={form.subtitle}
								onChange={e => handleChange(e, 'subtitle')}
								sx={{ width: '100%' }}
								disabled={isAssignRole}
							/>
						</Grid>

						<Grid item xs={12} sm={6} lg={isStandardFlow ? 6 : 3} xl={isStandardFlow ? 6 : 2}>
							<CustomTextField
								placeholder={t('standardStatus.table.icon')}
								label={t('standardStatus.table.icon')}
								value={form.icon}
								onChange={(e) => handleChange(e, 'icon')}
								disabled={isAssignRole}
								sx={{ width: '100%' }}
							/>
						</Grid>

						<Grid item xs={12} sm={6} lg={isStandardFlow ? 6 : 3}>
							<ContainerInputColor>
								<CustomFormLabel style={{ marginBottom: '0px' }}>
									{t('standardStatus.changeColor')}
								</CustomFormLabel>
								<InputColor
									initialValue={form.color}
									onChange={(e) => handleChange(e, 'color')}
									placement="start"
									disabled={isAssignRole}
								/>

								<div style={{ marginLeft: '1.5rem' }}>
									{getIcon(form)}
								</div>
							</ContainerInputColor>
						</Grid>

						<Grid item xs={12} sm={6} lg={isStandardFlow ? 6 : 3}>
							<CustomTextField
								type={'number'}
								placeholder={t('standardStatus.table.maxTime')}
								label={t('standardStatus.table.maxTime')}
								value={form.maxTime}
								onChange={(e) => handleChange(e, 'maxTime')}
								disabled={isAssignRole}
								sx={{ width: '100%' }}
							/>
						</Grid>

						<Grid item xs={12} sm={6} lg={isStandardFlow ? 6 : 3}>
							<CustomTextField
								type={'number'}
								placeholder={t('standardStatus.table.minTime')}
								label={t('standardStatus.table.minTime')}
								value={form.minTime}
								onChange={(e) => handleChange(e, 'minTime')}
								disabled={isAssignRole}
								sx={{ width: '100%' }}
							/>
						</Grid>

						<Grid item xs={12} lg={isStandardFlow ? 6 : 3}>
							<AntSwitchControlLabel
								control={
									<AntSwitch checked={form.notificationEmail}
										onChange={(e) => handleChange(e, 'notificationEmail')}
										inputProps={{ 'aria-label': 'controlled' }}
									/>
								}
								label={t('workflowManagement.flowState.notificacionEmail')}
								disabled={isAssignRole}
							/>
						</Grid>

						<Grid item lg={3} sx={{ display: {xs: 'none', lg: 'flex'} }}></Grid>

						{isAssignRole &&
							<>

							<Grid item xs={12} sm={6} xl={3}>
								<SelectInput
									label={t('workflowManagement.flowState.responsibleRole')}
									id="combo-box-demo"
									disableClearable
									onChange={(value) => handleChange(value, 'roles')}
									keyValue="name"
									value={form.roles}
									options={roles}
									multiple={true}
								/>
							</Grid>

							<Grid item xs={12} sm={6} xl={3}>
								<SelectInput
									label={t('workflowManagement.flowState.table.roleExecute')}
									onChange={(value) => handleChange(value, 'executeOption')}
									keyValue="name"
									value={form.executeOption}
									options={executeOptions}
								/>
							</Grid>

							<Grid item xs={12} mt={2}>
								<CustomDivider/>
							</Grid>

							<Grid item xs={12} display="flex" justifyContent="flex-end">
								<CustomButtonV2 btnType="primary" isStandard={true}
									onClick={() => handleSave(Router.appWorkflowStatus.replace(':id', form.idDetail))}
									startIcon={<SaveOutlined />}
									sx={{ width: '120px' }}
								>
									{t('common.edit')}
								</CustomButtonV2>
							</Grid>
							</>
						}

                    </Grid>
                </ContainerInfo>
            </Body>
            {!isAssignRole &&
                <ModalFooter>
                    <SectionRight>
                        <CustomButtonV2
                            btnType='cancel'
                            onClick={handleClose}
                        >
                            {t('common.cancel')}
                        </CustomButtonV2>
                        <CustomButtonV2
                            btnType="primary"
                            onClick={handleSave}
                        >
                            {t('common.save')}
                        </CustomButtonV2>
                    </SectionRight>
                </ModalFooter>
            }
        </Container>
    )
}
